<template>
  <div class="frame-item-container">
    <label class="IL-frame__label d-block text-center">
      {{title}}
      <span class="IL-frame__value d-inline-block">
        ({{selectedNode.data.frame[index] - 1 | value2label(type)}})
      </span>
    </label>
    <b-input
      min="0"
      max="7"
      type="range"
      class="IL-frame__input"
      :disabled="selectedNode.disabled"
      :value="selectedNode.data.frame[index]"
      @change="update" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { value2label, frameLabels } from '@/utils'

export default {
  name: 'frameItem',
  filters: {
    value2label
  },
  props: {
    index: {
      type: String,
      required: true,
      validator: value => ['PL', 'PI', 'NL', 'NI'].includes(value)
    }
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters(['selectedNode']),
    type () {
      return this.index[1]
    },
    title () {
      return {
        L: 'Likelihood',
        I: 'Intensity'
      }[this.type]
    },
    dict () {
      return ['N/A', ...frameLabels[this.type.toLowerCase()]]
    }
  },
  methods: {
    update (value) {
      this.selectedNode.data.frame[this.index] = Number(value)
      this.$emit('update', this.selectedNode)
    },
    flavorizer (list) {
      return list === 'main'
        ? { color: this.index[0] === 'P' ? '#28a745' : '#dc3545' }
        : '{}'
    }
  }
}
</script>

<style lang="scss">
  .frame-item-container {
    overscroll-behavior-x: contain;
  }
  .IL-frame {
    &__input {
      &, &:focus {
        box-shadow: none;
        cursor: pointer;
      }
    }
    &__label {
      font-weight: bold;
    }
    &__value {
      margin-left: 0.5em;
    }
  }
</style>
